import { AnimalDataSet } from '@dinnisoft/esteio-gestao-common';
import { Divider, Stack, Tooltip, Typography } from '@mui/material';

import { ItemText } from '../styles';

export const getBackgroundColor = (index: number) => (index % 2 === 0 ? '#f0f0f0' : '#fafafa');

export const FichaItemList: React.FC<{ items: AnimalDataSet[] }> = ({ items }) => {
  return (
    <Stack
      direction="column"
      divider={<Divider color="#9e9e9e" orientation="horizontal" flexItem />}
    >
      {items.map((item, index) => (
        <ItemText
          key={index}
          primary={
            <Tooltip title={item.tooltip} placement="top" followCursor describeChild>
              <Typography width="fit-content">{item.primary}</Typography>
            </Tooltip>
          }
          secondary={item.secondary ?? '-'}
          sx={{ bgcolor: getBackgroundColor(index), margin: 0 }}
        />
      ))}
    </Stack>
  );
};
